// ── Task App handoff link builder (C1389, renamed/widened C1559) ──
//
// Builds the URL for the web app's "Start in Task App" button (task-detail.js) — the local
// Task App server's /start-task bridge route (formerly /open-objective — that path is kept as
// an alias server-side, see ws-handlers.js), which resolves the project, verifies the
// signed-in account, fetches the task, and (only once all three pass) dispatches on the task's
// shape: a childless objective seeds an origin-linked Objective tab, an objective with
// children starts the first startable one, a regular task starts directly. See
// ai/architecture/tt-objective-chat.md § Web→Task App handoff (C1389/C1559).
//
// The web app deliberately does NOT decide which of the 3 branches applies — it can't see the
// real child set reliably (options.allTasks degrades to [] on a failed prefetch, and is stale
// between render and click); the Task App re-fetches the task and its children itself.
//
// Known limitation: nothing anywhere records a device's actual local Task App URL/port —
// devices/device_projects (migration 007) store no path or port (see tt-api-devices.md).
// 4455 is just the Task App's hardcoded default (ai/todo/server/src/server/config.js). The
// localStorage key below is an escape hatch for a non-default port; there is no UI to set it
// yet, so this only helps someone who sets it manually via devtools.
const DEFAULT_TASK_APP_URL = 'http://localhost:4455';
const OVERRIDE_KEY = 'tt_task_app_url';

function taskAppBaseUrl() {
  try {
    return localStorage.getItem(OVERRIDE_KEY) || DEFAULT_TASK_APP_URL;
  } catch {
    return DEFAULT_TASK_APP_URL;
  }
}

// projectId/taskKey/userId are all required by the receiving /start-task route.
export function buildStartTaskUrl({ projectId, taskKey, userId }) {
  const base = taskAppBaseUrl().replace(/\/+$/, '');
  const params = new URLSearchParams({
    projectId: String(projectId),
    task: taskKey,
    userId: String(userId),
  });
  return `${base}/start-task?${params.toString()}`;
}
